/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
const PREFIX = "OFFLINE_MODE";
const SET_OFFLINE_MODE = `${PREFIX}_SET_OFFLINE`;
const SET_ONLINE_MODE = `${PREFIX}_SET_ONLINE`;

const GET_DOWNLOADED_PODCASTS = `${PREFIX}_GET_DOWNLOADED_PODCASTS`;
const GET_DOWNLOADED_PODCASTS_SUCCESS = `${PREFIX}_GET_DOWNLOADED_PODCASTS_SUCCESS`;
const GET_DOWNLOADED_PODCASTS_FAILURE = `${PREFIX}_GET_DOWNLOADED_PODCASTS_FAILURE`;

const START_DOWNLOAD = `${PREFIX}_START_DOWNLOAD`;
const START_DOWNLOAD_SUCCESS = `${PREFIX}_START_DOWNLOAD_SUCCESS`;
const START_DOWNLOAD_FAILED = `${PREFIX}_START_DOWNLOAD_FAILED`;
const SET_DOWNLOAD_PROGRESS = `${PREFIX}_SET_DOWNLOAD_PROGRESS`;

const UPDATE_PODCAST = `${PREFIX}_UPDATE_PODCASTS_MEDIA`;
const UPDATE_PODCAST_SUCCESS = `${PREFIX}_UPDATE_PODCASTS_SUCCESS`;
const UPDATE_PODCAST_FAILURE = `${PREFIX}_UPDATE_PODCASTS_FAILURE`;

const DELETE_PODCAST = `${PREFIX}_DELETE_DOWNLOADED_MEDIA`;
const DELETE_PODCAST_SUCCESS = `${PREFIX}_DELETE_PODCASTS_SUCCESS`;
const DELETE_PODCAST_FAILURE = `${PREFIX}_DELETE_PODCASTS_FAILURE`;

const ADD_TO_QUEUE = `${PREFIX}_ADD_TO_QUEUE`;
const ADD_JOB_ID = `${PREFIX}_ADD_JOB_ID`;

export const ActionTypes = {
  SET_OFFLINE_MODE,
  SET_ONLINE_MODE,
  GET_DOWNLOADED_PODCASTS,
  GET_DOWNLOADED_PODCASTS_SUCCESS,
  GET_DOWNLOADED_PODCASTS_FAILURE,
  START_DOWNLOAD,
  START_DOWNLOAD_SUCCESS,
  START_DOWNLOAD_FAILED,
  SET_DOWNLOAD_PROGRESS,
  UPDATE_PODCAST,
  UPDATE_PODCAST_SUCCESS,
  UPDATE_PODCAST_FAILURE,
  DELETE_PODCAST,
  DELETE_PODCAST_SUCCESS,
  DELETE_PODCAST_FAILURE,
  ADD_TO_QUEUE,
  ADD_JOB_ID,
};
